module.exports = __webpack_public_path__ + "img/web3.6ed14277.png";